// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"362":"28250aa3c15aa160","382":"a6a1f680ddcfd9da","603":"35c5cd36c5ca3686","620":"9c4256a3f1dafefd","621":"d2012115ad6460cd","673":"7a3b82ffb75ef175","809":"fbc4de85300d5c25","894":"758fbaac9c0e9fbe"}[chunkId] + ".js";
};